import type { ComponentPropsWithoutRef } from "react"
import Link from "next/link"
import cn from "classnames"

import { Icon } from "~/components/primitives/icon"
import type { CtaLink as CtaLinkType } from "~/types/cms"
import type { Theme } from "~/types/general"

import s from "./TertiaryButton.module.scss"

type TertiaryButtonProps = {
  cta: CtaLinkType
  className?: string
  theme?: Theme
} & ComponentPropsWithoutRef<"a">

export const TertiaryButton = ({
  cta,
  className = "",
  theme = "light",
  ...rest
}: TertiaryButtonProps) => {
  const { url, label } = cta

  if (!url) {
    return null
  }

  return (
    <Link
      href={url}
      className={cn(s.tertiaryButton, s[theme], className)}
      {...rest}
    >
      <span className={s.label}>{label}</span>
      <span className={s.iconWrapper}>
        <span className={s.iconTrack}>
          <Icon id="link-arrow" className={s.icon} aria-hidden="true" />
          <Icon id="link-arrow" className={s.icon} aria-hidden="true" />
        </span>
      </span>
    </Link>
  )
}
